import { useState } from "react";
import { faqs } from "@/mocks/content";
import { Reveal, SectionHeading } from "./common";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="section-anchor w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 max-w-4xl mx-auto">
        <Reveal>
          <SectionHeading
            eyebrow="常见疑问"
            align="center"
            title="关于剧情与结局，观众最常问的几个问题"
            desc="下面整理了搜索「善良的嫂子剧透」时最常被提及的疑问，点击问题即可展开解答。"
          />
        </Reveal>

        <div className="mt-8 md:mt-10 space-y-3">
          {faqs.map((item, i) => {
            const isOpen = openIndex === i;
            return (
              <Reveal key={item.q} delay={i * 40}>
                <div className="rounded-lg bg-background-50 border border-background-200 overflow-hidden">
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    className="w-full flex items-center gap-4 text-left p-4 md:p-5 cursor-pointer"
                  >
                    <i className="ri-question-line text-primary-500 text-lg shrink-0"></i>
                    <span className="flex-1 font-heading text-sm md:text-base font-semibold text-foreground-900">
                      {item.q}
                    </span>
                    <i
                      className={`shrink-0 text-xl text-foreground-400 transition-transform ${
                        isOpen ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"
                      }`}
                    ></i>
                  </button>
                  {isOpen && (
                    <div className="px-4 md:px-5 pb-5 pl-11 md:pl-12 animate-fade-in-down">
                      <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                    </div>
                  )}
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}